/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import type { CosmosCardProps } from "@components/elements/atoms";
import { BlogCardFragment } from "@cosmos/hygraph-schema";
import { cva, cx, RecipeVariantProps } from "@panda/css";
import { BlogCard } from "./BlogCard.molecule";

const cardStyle = cva({
	base: {
		display: "grid",
		gap: "eds.dimension.16",
	},
	variants: {
		maxRowSize: {
			1: { gridTemplateColumns: { base: "1", mdDown: "1" } },
			2: { gridTemplateColumns: { base: "2", mdDown: "1" } },
			3: { gridTemplateColumns: { base: "3", mdDown: "1" } },
			4: { gridTemplateColumns: { base: "4", mdDown: "1" } },
		},
	},
});

type BlogCardStyleVariants = RecipeVariantProps<typeof cardStyle>;
export type BlogCardsProps = BlogCardStyleVariants & {
	className?: string;
	cards?: BlogCardFragment[] | null;
	direction?: CosmosCardProps["direction"];
	rowSizeOveride?: NonNullable<BlogCardStyleVariants>["maxRowSize"];
};

type RowSize = (typeof cardStyle.variantMap.maxRowSize)[number];
const ROW_TOKENS = cardStyle.variantMap.maxRowSize;

const VARIANT_LABELS = ["single", "double", "triple", "quadruple"] as const;
type BlogCardVariant = (typeof VARIANT_LABELS)[number];

const selectByIndex = <T,>(items: readonly T[], n: number): T => items[Math.max(0, Math.min(items.length - 1, n - 1))];
const getRowSize = (count: number, max: number): RowSize => selectByIndex(ROW_TOKENS, Math.min(count, max));
const getVariant = (len: number): BlogCardVariant => selectByIndex(VARIANT_LABELS, len);

export function BlogCards({
	cards = [],
	className,
	maxRowSize = 3,
	direction,
	rowSizeOveride,
}: BlogCardsProps): React.JSX.Element | null {
	if (!cards || !cards.length) return null;

	const rowSize = rowSizeOveride || getRowSize(cards.length, maxRowSize);
	const variant = getVariant(cards.length);
	if (!direction) {
		direction = variant === "single" ? "mdRow" : "column";
	}

	return (
		<div className={cx("blog-cards", className, cardStyle({ maxRowSize: rowSize }))}>
			{(cards || []).map((card, i) => (
				<BlogCard key={`blog-card-grid-item-${i}`} {...card} variant={variant} direction={direction} />
			))}
		</div>
	);
}
